export enum AddSegmentType {
  INTRO = 'intro',
  OUTRO = 'outro'
}
